import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"



export function loginV2S1(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/login/loginV2S1`, params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function loginV2SE(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/login/loginV2SE`, params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function regV2S1(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/login/regV2S1`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function regV2SE(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/login/regV2SE`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function userRoleConfig() {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/role_info`)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function login(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/login/access_token`, params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function accountSetting(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/account_setting`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function accountInfo(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/info`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getPersonalInfo(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/get_personal_info`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getPreperences(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/get_preperences`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getNotifications(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/get_notifications`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function baseInfo(params) {
  return new Promise((resolve, reject) => {
    get(`${url_domain()}${url_pre()}/account/base_info`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export function updatePersonalInfo(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/account/update_personal_info`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export function updatePreperences(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/account/update_preperences`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export function updateNotifications(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/account/update_notifications`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function udpateAvatar(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/account/update_avatar`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function udpatePassword(params) {
  return new Promise((resolve, reject) => {
    postJson(`${url_domain()}${url_pre()}/account/update_password`, params)
      .then(res => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function findUserInfo(params) {
  return new Promise((resolve, reject) => {
    post("/api/userInfo/findUserInfo", params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function findUnderFromUser(params) {
  return new Promise((resolve, reject) => {
    post("/api/userInfo/findUnderFromUser", params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function sendSMSCode(params) {
  return new Promise((resolve, reject) => {
    post("/api/smsAuthCode", params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function isRegistered(params) {
  return new Promise((resolve, reject) => {
    post("/api/userInfo/isRegistered", params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default {
  login
}
